import { parseBackendUtcTimestamp } from './liveIntegration';

export const CLASSROOM_GRANT_STORAGE_KEY = 'gymgpt.classroomGrant.v1';

export interface StoredClassroomGrant {
  expires_at: string;
}

function readRawGrant(): StoredClassroomGrant | null {
  try {
    const raw = sessionStorage.getItem(CLASSROOM_GRANT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    const expiresAt = (parsed as { expires_at?: unknown }).expires_at;
    if (typeof expiresAt !== 'string' || !expiresAt.trim()) {
      return null;
    }
    return { expires_at: expiresAt.trim() };
  } catch {
    return null;
  }
}

export function readClassroomGrant(): StoredClassroomGrant | null {
  const grant = readRawGrant();
  if (!grant) {
    return null;
  }
  try {
    parseBackendUtcTimestamp(grant.expires_at);
    return grant;
  } catch {
    return null;
  }
}

export function writeClassroomGrant(grant: StoredClassroomGrant): boolean {
  try {
    parseBackendUtcTimestamp(grant.expires_at);
    sessionStorage.setItem(CLASSROOM_GRANT_STORAGE_KEY, JSON.stringify(grant));
    return true;
  } catch {
    return false;
  }
}

export function clearClassroomGrant(): void {
  try {
    sessionStorage.removeItem(CLASSROOM_GRANT_STORAGE_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function isClassroomGrantActive(now = Date.now()): boolean {
  const grant = readClassroomGrant();
  if (!grant) {
    return false;
  }
  try {
    return now < parseBackendUtcTimestamp(grant.expires_at);
  } catch {
    return false;
  }
}
